import { render, staticRenderFns } from "./creationCompetitionOne.vue?vue&type=template&id=37d27a16&scoped=true"
import script from "./creationCompetitionOne.vue?vue&type=script&lang=js"
export * from "./creationCompetitionOne.vue?vue&type=script&lang=js"
import style0 from "./creationCompetitionOne.vue?vue&type=style&index=0&id=37d27a16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d27a16",
  null
  
)

export default component.exports